import type { AdVenueOptionDto } from '@lib/dto/ads.dto'
import type { AdPlaceInput } from '@lib/input/ads.input'

/** One place an account or campaign can count toward, as a picker shows it. */
export interface AdPlaceOption {
  /** `venueId`, or `venueId/trackId`. Ids are UUIDs, which never hold a slash. */
  key: string
  label: string
}

export function adPlaceKey(place: { venueId: string; trackId: string | null }): string {
  return place.trackId === null ? place.venueId : `${place.venueId}/${place.trackId}`
}

export function parseAdPlaceKey(key: string): AdPlaceInput | null {
  const [venueId, trackId] = key.split('/')
  if (venueId === undefined || venueId === '') return null
  return { venueId, trackId: trackId ?? null }
}

/** Every venue as a whole, then each of its tracks: "Falls Creek Farm", "Falls Creek Farm · The Reserve". */
export function adPlaceOptions(venues: AdVenueOptionDto[]): AdPlaceOption[] {
  return venues.flatMap((venue) => [
    { key: venue.id, label: venue.name },
    ...venue.tracks.map((track) => ({ key: `${venue.id}/${track.id}`, label: `${venue.name} · ${track.name}` })),
  ])
}

/** A place in words, or null when its venue is no longer one of the company's live venues. */
export function adPlaceLabel(place: { venueId: string; trackId: string | null }, venues: AdVenueOptionDto[]): string | null {
  const venue = venues.find((v) => v.id === place.venueId)
  if (venue === undefined) return null
  const track = venue.tracks.find((t) => t.id === place.trackId)
  return track === undefined ? venue.name : `${venue.name} · ${track.name}`
}
